import * as R_ from 'ramda-extension';

export default R_.keyMirror({
	CLOSE_MODAL: null,
	OPEN_MODAL: null,
	SET_MODAL_DATA: null,
	SLIDE_MODAL: null,
});
